import { render, staticRenderFns } from "./InputType.vue?vue&type=template&id=23e3cb7e&scoped=true&"
import script from "./InputType.vue?vue&type=script&lang=ts&"
export * from "./InputType.vue?vue&type=script&lang=ts&"
import style0 from "./InputType.vue?vue&type=style&index=0&id=23e3cb7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e3cb7e",
  null
  
)

export default component.exports